let currentSlide = 0

function showSlide (index) {
  const slides = document.querySelectorAll('.ubuntu-blog-slide-item')
  const totalSlides = slides.length

  if (index >= totalSlides) {
    currentSlide = totalSlides - 1
  } else if (index < 0) {
    currentSlide = 0
  } else {
    currentSlide = index
  }

  const sliderContainer = document.querySelector('.ubuntu-blog-slider-container')
  if (sliderContainer) {
    sliderContainer.style.transform = `translateX(-${currentSlide * 100}%)`
  }

  // Disable navigation buttons based on currentSlide
  updateNavigationButtons()
}

// eslint-disable-next-line no-unused-vars
function moveSlide (direction) {
  showSlide(currentSlide + direction)
}

function updateNavigationButtons () {
  const prevButton = document.querySelector('.ubuntu-blog-slider-footer-nav button.prev')
  const nextButton = document.querySelector('.ubuntu-blog-slider-footer-nav button.next')

  if (!prevButton || !nextButton) {
    return
  }

  // Disable the previous button if at the first slide
  if (currentSlide === 0) {
    prevButton.disabled = true
  } else {
    prevButton.disabled = false
  }

  // Disable the next button if at the last slide
  const totalSlides = document.querySelectorAll('.ubuntu-blog-slide-item').length
  if (currentSlide === totalSlides - 1) {
    nextButton.disabled = true
  } else {
    nextButton.disabled = false
  }
}

showSlide(currentSlide)

const navigationButtons = document.querySelectorAll('.ubuntu-blog-slider-footer-nav button')

navigationButtons.forEach(button => {
  button.addEventListener('click', () => {
    moveSlide(button.classList.contains('prev') ? -1 : 1)
  })
})

const scrollContainer = document.querySelector('.ubuntu-blog-categories-nav-inner')

let isThrottled = false
const throttleDelay = 125

scrollContainer.addEventListener('wheel', (e) => {
  e.preventDefault()

  if (!isThrottled) {
    const scrollAmount = e.deltaY * 2.25
    scrollContainer.scrollLeft += scrollAmount

    isThrottled = true
    setTimeout(() => {
      isThrottled = false
    }, throttleDelay)
  }
})
